import { render, staticRenderFns } from "./DeleteProductModal.vue?vue&type=template&id=22a52170&scoped=true&"
import script from "./DeleteProductModal.vue?vue&type=script&lang=js&"
export * from "./DeleteProductModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteProductModal.vue?vue&type=style&index=0&id=22a52170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a52170",
  null
  
)

export default component.exports